<template>
    <div class="card card-custom gutter-b card-stretch ">
        <div class="card-header border py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Generación y descarga de credenciales de participación</span>
                <span class="text-muted mt-3 font-weight-bold font-size-sm">Deportistas y  Oficiales</span>
            </h3>
        </div>
        <div class="card-body">

            <el-alert
                type="success"
                description="Credenciales disponibles solo para deportistas y oficiales debidamente acreditados y aprobados."
                show-icon class="mb-8">
            </el-alert>

            <!--start section filter-->
            <div class="row my-4">
                <div class="col-sm-6">
                    <div class="d-flex align-items-center">
                        <label class="mr-3">Evento</label>
                        <el-select v-model="formFilter.idevent"  placeholder="Seleccione un evento" size="small" class="w-100" @change="getSports">
                            <el-option v-for="item in listEvents" :key="item.idevent" :label="item.name" :value="item.idevent" ></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <!--end section filter-->
            <el-tabs v-model="formFilter.activeTab"  @tab-click="handleClick">
                <el-tab-pane label="Deportistas y Oficiales Técnicos" name="a">
                    <div class="row my-4">
                        <div class="col-sm-3">
                            <div class="d-flex align-items-center">
                                <label class="mr-3">Disciplina</label>
                                <el-select v-model="formFilter.idsport" placeholder="Seleccione un deporte" size="small" class="w-100" @change="getData">
                                    <el-option v-for="item in listSports" :key="item.idsport" :label="item.name" :value="item.idsport"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <el-table
                        :data="table1.filter(data => !search1 || data.firstname.toLowerCase().includes(search1.toLowerCase()))"
                        style="width: 100%" height="500px">
                        <el-table-column label="N° Documento" >
                            <template #default="scope" width="100px">
                                <span class="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{scope.row.docnumber}}</span>
                                <span class="text-secondary font-weight-bold d-block">{{scope.row.docName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Participante">
                            <template #default="scope">
                                <div class="d-flex flex-column flex-grow-1 font-weight-bold">
                                    <div class="text-hover-primary mb-0 font-size-lg"> {{scope.row.firstname}} </div>
                                    <span class=""> {{scope.row.lastname + ' ' + scope.row.surname}}</span>
                                </div>
                            </template>
                            
                        </el-table-column>
                        <el-table-column label="Sexo">
                            <template #default="scope">
                                    <span v-if="scope.row.gender=='F'" class="label font-weight-bold label-lg label-light-danger label-inline">{{scope.row.gender}}</span>
                                    <span v-else class="label font-weight-bold label-lg label-light-success label-inline">{{scope.row.gender}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Función" prop="funcName"></el-table-column>
                        <el-table-column label="Registrado" prop="created_at"></el-table-column>
                        <el-table-column align="right">
                            <template #header>
                                <el-input v-model="search1" size="small" placeholder="Buscar por nombre"/>
                            </template>
                            <template #default="scope">
                                <div class="btn btn-sm btn-primary" :key="scope.name" @click="generate(scope.row.idacreditation)"><i class="el-icon-download"></i> Descargar</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <el-tab-pane label="Oficiales Administrativos" name="b">
                    <el-table
                        :data="table2.filter(data => !search2 || data.firstname.toLowerCase().includes(search2.toLowerCase()))"
                        style="width: 100%" height="500px">
                        <el-table-column label="N° Documento" >
                            <template #default="scope" width="100px">
                                <span class="text-dark-50 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{scope.row.docnumber}}</span>
                                <span class="text-secondary font-weight-bold d-block">{{scope.row.docName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="Participante">
                            <template #default="scope">
                                <span>{{scope.row.firstname}}</span>
                            </template>
                            
                        </el-table-column>
                        <el-table-column label="Sexo" prop="gender"></el-table-column>
                        <el-table-column label="Función" prop="funcName"></el-table-column>
                        <el-table-column label="Registrado" prop="created_at"></el-table-column>
                        <el-table-column align="right">
                            <template #header>
                                <el-input v-model="search2" size="small" placeholder="Buscar por nombre"/>
                            </template>
                            <template #default="scope">
                                <div class="btn btn-sm btn-primary" :key="scope.name" @click="generate(scope.row.idacreditation)"><i class="el-icon-download"></i> Descargar</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>
        </div>
    </div>
</template>

<script>
//services
import code from "@/core/config/status.code";
import { UniService, AuthenticationError } from '@/core/services/uni.service';
import { CredentialService, credentialError } from '@/core/services/credentials.service';
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";

export default {
    name: 'credentials',
    data: () => ({
        listEvents: [],
        listSports: [],
        search1: '',
        search2: '',
        table1: [],
        table2: [],
        formFilter:{
            activeTab: 'a',
            idevent: null,
            idsport: null
        },
    }),
    methods: {
        handleClick(tab, event) {
            if(this.formFilter.activeTab == 'a'){
                if(this.formFilter.idevent !=null && this.formFilter.idsport != null)
                    this.loadData();
            }
            if(this.formFilter.activeTab == 'b'){
                if(this.formFilter.idevent !=null)
                    this.loadData();
            }
        },
        async getEvents(){
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Events();
                this.listEvents = res.data.events;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async getSports(){
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Sports(this.formFilter.idevent);
                this.listSports = res.data;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if(this.formFilter.activeTab == 'b'){
                    loadData();
                }
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async loadData(){
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await CredentialService.loadAthleteOfficers(this.formFilter);
                if(res.data.tipo == 1)
                    this.table1 = res.data.credentials
                else
                    this.table2 = res.data.credentials;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof credentialError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        getData(){
            if(this.formFilter.idevent !=null && this.formFilter.idsport != null)
                this.loadData();
        },
        generate(id){
            let url = process.env.VUE_APP_URL_BACKEND + `credentials/generate/${window.btoa(id)}`;
            window.open(url, '_blank');
        }
    }, 
    created(){
        this.getEvents();

    }
}
</script>
